import { useEffect, useState, useCallback } from "react";
import AuditIntens from "../Componentes/AuditInterna/AuditItens";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import { useParams } from "react-router-dom";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import AddNewItem from "../Componentes/AuditInterna/AddNewItem";
import { ToastContainer } from 'react-toastify';
import { useModal } from "../contexts/ModalContext";
import EditItem from "../Componentes/AuditInterna/EditItem";
import CancelSquare from "../Componentes/AuditInterna/CanecelSquare";
import FinishSquare from "../Componentes/AuditInterna/FinishSquare";

import { saveAs } from "file-saver";

import useApi from "../hooks/useApi";
const AuditoriaInternaId = () => {
    const api = useApi();


    const { id } = useParams();

    const [auditInfo, setAuditInfo] = useState({
        contrato: '',
        data: '',
        status: '',
        itensC: 0,
        itensNC: 0,
        itensNA: 0,
        itensOM: 0,
        percent: ''
    })

    const [itensAudit, setItensAudit] = useState([])
    const [itensAuditFilter, setItensAuditFilter] = useState([])

    const fetchAuditItens = async () => {

        try {

            const { data } = await api.post('/Painel/API/AuditInterna/GetAuditItens/', {
                id: id
            })

            console.log(data)

            setAuditInfo({
                contrato: data.contrato,
                data: data.data_prev_inicio,
                status: data.status,
                itensC: data.itens_c,
                itensNC: data.itens_nc,
                itensNA: data.itens_na,
                itensOM: data.itens_om,
                percent: data.percent
            })

            setItensAudit(data.itens);
            setItensAuditFilter(data.itens);

        } catch (error) {

            console.error(error);

        }

    }

    useEffect(() => {

        fetchAuditItens();

    }, [])

    const handleFilter = useCallback((
        normaFilter,
        itemFilter,
        auditorFilter,
        auditadoFilter,
        setoresFilter,
        confFilter
    ) => {

        const toValueSet = (selected) => {
            if (!Array.isArray(selected) || selected.length === 0) return null;
            return new Set(
                selected.map((item) =>
                    item != null && typeof item === 'object' && 'value' in item
                        ? item.value
                        : item
                )
            );
        };

        const normaSet = toValueSet(normaFilter);
        const subitemSet = toValueSet(itemFilter);
        const auditorSet = toValueSet(auditorFilter);
        const auditadoSet = toValueSet(auditadoFilter);
        const setoresSet = toValueSet(setoresFilter);
        const confSet = toValueSet(confFilter);

        const filtered = itensAudit.filter((item) => {
            const norma =
                !normaSet ||
                [...normaSet].some((v) => item.norma.includes(v));
            const subitem =
                !subitemSet ||
                [...subitemSet].some((v) => item.subitem.includes(v));
            const auditor =
                !auditorSet ||
                [...auditorSet].some((v) => item.auditor.includes(v));
            const auditado =
                !auditadoSet ||
                [...auditadoSet].some((v) => item.auditado.includes(v));
            const setor = !setoresSet || setoresSet.has(item.setor);
            const conformidade =
                !confSet || confSet.has(item.conformidade);

            return norma && subitem && auditor && auditado && setor && conformidade;
        });

        setItensAuditFilter(filtered);

    }, [itensAudit]);

    const { openModal, isModalOpen } = useModal();

    const [sideOverlay, setSideOverlay] = useState(false);

    const [cancelOverlay, setCancelOverlay] = useState(false);
    const [finishOverlay, setFinishOverlay] = useState(false); 

    const openSideBar = () => {

        setSideOverlay(true);

    }

    const closeSideBar = () => {

        setSideOverlay(false);

    }

    const openForm = () => {
        setSideOverlay(false);
        openModal('auditInternaNovoItem');
    };

    const openCheckList = () => {

        window.open(`/modulo/ssma/check-auditoria/${ id }`)

    }

    const openCancel = () => {

        setSideOverlay(false);
        setCancelOverlay(true);

    }

    const closeCancel = () => {

        setCancelOverlay(false);

    }

    const openFinish = () => {

        setSideOverlay( false )
        setFinishOverlay( true )

    }

    const closeFinish = () => {

        setFinishOverlay( false )

    }

    const [itemEdit, setItemEdit] = useState(null)

    const openItemEdit = (item) => {
        setItemEdit(item);
        openModal('auditInternaEditItem');
    };

    const [ loadRelat, setLoadRelat ] = useState( false );

    const downloadRelat = async () => {

        setLoadRelat(true);

        try{

            const { data } = await api({
                url: '/Painel/API/AuditInterna/DownloadRelatorio/',
                method: 'POST',
                responseType: 'blob',
                data: {
                    itens: itensAuditFilter,
                    id: id    
                }
            })

            const blob = new Blob([data], { type: 'application/pdf' })
            saveAs( blob, 'arquivo.pdf' )

        }catch( error ){

            console.log( error )

        }finally{

            setLoadRelat(false);

        }

    }

    return (
        <>
            <NavBar
                title={"ITENS AUDITORIA - " + auditInfo.contrato + " | " + auditInfo.data}
                changeState={openSideBar}
                goBackOnePage
            />
            <AuditIntens
                itens={itensAuditFilter}
                itensToFilter={itensAudit}
                percentage={auditInfo.percent}
                openEdit={openItemEdit}
                handleFilter={handleFilter}
                onItemDeleted={fetchAuditItens}
            />
            {
                sideOverlay && (
                    <Overlay
                        state={true}
                        changeContent={closeSideBar}
                    >
                        <SideMenu>
                            {(auditInfo.status !== 'CANCELADO' && auditInfo.status !== 'FINALIZADO') && (
                                <SideMenuBtn
                                    button="REGISTRAR NOVO ITEM"
                                    clickFunc={openForm}
                                />
                            )}

                            <SideMenuBtn
                                button="ITENS PENDENTES"
                                clickFunc={openCheckList}
                            />

                            <SideMenuBtn
                                button="CANCELAR AUDITORIA"
                                clickFunc={openCancel}
                            />
                            <SideMenuBtn
                                button="FINALIZAR AUDITORIA"
                                clickFunc={openFinish}
                            />
                            <SideMenuBtn
                                button="GERAR RELATÓRIO"
                                isLoading={ loadRelat }
                                clickFunc={downloadRelat}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {isModalOpen('auditInternaNovoItem') && (
                <AddNewItem
                    auditoria={id}
                    updateItens={fetchAuditItens}
                />
            )}
            {isModalOpen('auditInternaEditItem') && itemEdit != null && (
                <EditItem
                    key={itemEdit}
                    itemSelected={itemEdit}
                    onClose={() => setItemEdit(null)}
                    updateItens={fetchAuditItens}
                />
            )}
            {
                cancelOverlay && (
                    <Overlay state={true} >
                        <CancelSquare
                            close={closeCancel}
                            updateAudit={ fetchAuditItens }
                        />
                    </Overlay>
                )
            }
            {
                finishOverlay && (
                    <Overlay state={ true } >
                        <FinishSquare
                            close={ closeFinish }
                            updateAudit={ fetchAuditItens }
                        />
                    </Overlay>
                )
            }
            <ToastContainer
                style={{
                    zIndex: 99999
                }}
                autoClose={3000}
                position="top-center"
                theme="dark"
            />
        </>
    )

}

export default AuditoriaInternaId;